import { Box, ButtonBase, Typography as T } from "@mui/material";

import { palette } from "theme/palette";

type Props = {
  page6Variant?: boolean;
  mobileVariant?: boolean;
  onClose?: () => void;
};

const EmptySummary = ({
  page6Variant = false,
  mobileVariant = false,
  onClose,
}: Props) => {
  return (
    <Box
      sx={{
        borderRadius: "16px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignSelf: "center",
        height: "100%",
      }}
    >
      <T
        variant="summaryEmptyDescription"
        style={{
          textAlign: "center",
          marginTop: "45px",
          color: palette.lightGrey,
        }}
      >
        Your order summary will display here after you finish selecting a
        service & vehicle
      </T>
      {!page6Variant && mobileVariant && (
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <ButtonBase
            sx={{
              height: "48px",
              borderColor: "rgba(183, 183, 183, 1)",
              borderRadius: "8px",
              width: "90%",
              marginRight: "30px",
              marginBottom: "24px",
              border: "2px solid rgba(183, 183, 183, 1)",
            }}
            onClick={onClose}
          >
            <T
              variant="h5sb"
              sx={{
                color: "rgba(183, 183, 183, 1)",
                marginRight: 1,
                fontSize: [16, 18],
              }}
            >
              Close
            </T>
          </ButtonBase>
        </Box>
      )}
    </Box>
  );
};

export default EmptySummary;
